import { render, staticRenderFns } from "./MinyukinAnkenLists.vue?vue&type=template&id=1c85f474"
import script from "./MinyukinAnkenLists.vue?vue&type=script&lang=js"
export * from "./MinyukinAnkenLists.vue?vue&type=script&lang=js"
import style0 from "./MinyukinAnkenLists.vue?vue&type=style&index=0&id=1c85f474&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports